import { Search } from '@vkontakte/vkui';
import React from 'react';
import('./SearchComponent.css');

export const SearchComponent = (props) => {
  return (<Search
    {...props}
    className="SearchComponent"
  />);
}